import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  DownloadButton,
  downloadReport
} from 'app/src/elements/ReportDownload'
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const FeesNotApprovedReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'fees-not-approved-report',
      params: { 'seller-id': sellerId }
    })
  }

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Fees Not Approved Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
};

export default FeesNotApprovedReport;
